'use strict';

var react = require('react');
var components_form_FormContext = require('../components/form/FormContext.js');

const FieldsetContext = react.createContext(undefined);
const useFieldsetContext = () => react.useContext(FieldsetContext);

const FieldContext = react.createContext(undefined);
const FieldContextProvider = FieldContext?.Provider;
const useFieldContext = () => react.useContext(FieldContext);
const useSynchronizedProps = ({ status: statusProperty, size: sizeProperty, disabled: disabledProperty, readOnly: readOnlyProperty, required: requiredProperty, inputType, }) => {
    const formContext = components_form_FormContext.useFormContext();
    const fieldsetContext = useFieldsetContext();
    const fieldContext = useFieldContext();
    const disabled = disabledProperty ?? fieldsetContext?.disabled ?? formContext?.disabled;
    const readOnly = readOnlyProperty ?? fieldsetContext?.readOnly ?? formContext?.readOnly;
    const required = requiredProperty ?? fieldsetContext?.required ?? formContext?.required;
    const status = statusProperty ?? fieldsetContext?.status ?? formContext?.status;
    const size = sizeProperty ?? fieldsetContext?.size ?? formContext?.size;
    react.useLayoutEffect(() => {
        fieldContext?.setDisabled(disabled);
        fieldContext?.setReadOnly(readOnly);
        fieldContext?.setRequired(required);
        fieldContext?.setStatus(status);
        fieldContext?.setSize(size);
        fieldContext?.setInputType(inputType);
    }, [fieldContext, disabled, readOnly, inputType, required, size, status]);
    return {
        status,
        size,
        disabled,
        readOnly,
        required,
    };
};

exports.FieldContextProvider = FieldContextProvider;
exports.FieldsetContext = FieldsetContext;
exports.useFieldContext = useFieldContext;
exports.useFieldsetContext = useFieldsetContext;
exports.useSynchronizedProps = useSynchronizedProps;
//# sourceMappingURL=FieldContext-DI94tJqT.js.map
